import http from '@/utils/http';

export default {
    save: data => {
        return http({url:'/api/admin/v1/warehouse/save',data,tip:true,loading:true}).then(r => r);
    },
    delete: data => {
        return http({url:'/api/admin/v1/warehouse/delete',data,tip:true,loading:true}).then(r => r);
    },
    list: data => {
        return http({url:'/api/admin/v1/warehouse/list',data}).then(r => r);
    },
    listAll: () => {
        return http({url:'/api/admin/v1/warehouse/listAll'}).then(r => r);
    },
}